var map = {
	"./img/clients-items/mgu/mgu-video.mp4": 1363,
	"./img/completo/completo-video.mp4": 1362,
	"./img/completo/msu-video.mp4": 2131,
	"./img/msu/msu-video.mp4": 2141,
	"./video/mts-main-products-boards.mp4": 2259,
	"./video/mts-main-products-chats.mp4": 2260,
	"./video/mts-main-products-comdi.mp4": 2261,
	"./video/mts-main-products-courses.mp4": 2262,
	"./video/mts-main-products-equipment.mp4": 2263,
	"./video/mts-main-products-forms.mp4": 2264,
	"./video/mts-main-products-meetings.mp4": 2265,
	"./video/mts-main-products-webinars.mp4": 2266,
	"./video/mts-products-chats-account-management.mp4": 2267,
	"./video/mts-products-chats-adding-employees.mp4": 2268,
	"./video/mts-products-chats-ai-assistant.mp4": 2269,
	"./video/mts-products-chats-appointment-moderators.mp4": 2270,
	"./video/mts-products-chats-chats-and-channels.mp4": 2271,
	"./video/mts-products-chats-distribution-groups.mp4": 2272,
	"./video/mts-products-chats-favorite-features.mp4": 2273,
	"./video/mts-products-chats-in-platform.mp4": 2143,
	"./video/mts-products-chats-one-click-call.mp4": 2274,
	"./video/mts-products-chats-promo-mobile.mp4": 2144,
	"./video/mts-products-chats-promo.mp4": 2194,
	"./video/mts-products-comdi.mp4": 2116,
	"./video/tab-intelligence-video.mp4": 2145,
	"./video/webinar-meetings.mp4": 2275,
	"./video/webinars-detail/auto-webinars.mp4": 2276,
	"./video/webinars-detail/banners.mp4": 2277,
	"./video/webinars-detail/branding.mp4": 2278,
	"./video/webinars-detail/engagement-monitoring.mp4": 2279,
	"./video/webinars-detail/groups.mp4": 2280,
	"./video/webinars-detail/metrics.mp4": 2281,
	"./video/webinars-detail/participant-testing.mp4": 2282,
	"./video/webinars-detail/questions-sorting.mp4": 2283,
	"./video/webinars-detail/simple-interface.mp4": 2284,
	"./video/webinars-detail/sync-translation.mp4": 2285,
	"./video/webinars-detail/technical-support.mp4": 2286,
	"./video/webinars-detail/tests-and-surveys.mp4": 2287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1365;